<!-- @defer only splits the bundle; it never un-renders, so the @if owns visibility. -->
@defer (on idle) {
  @if (clip.open()) {
    <wl-flyover-panel
      heading="Replay"
      intro="Plays your screen recording of this moment on a loop."
      closeLabel="Close replay"
      (closed)="clip.close()">
      <wl-clip-player />
    </wl-flyover-panel>
  }
}
